module.exports = __webpack_public_path__ + "src/img/bao.png?171142d1e42451cf0d623eddcc80eeba";


//////////////////
// WEBPACK FOOTER
// ./src/img/bao.png
// module id = 27
// module chunks = 0